module.exports = __webpack_public_path__ + "Hotels_ico.png?354717cf4d12fab5d5eff97217b25b03";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/Hotels_ico.png
// module id = 464
// module chunks = 0